import React from "react";
import { injectIntl, intlShape } from "react-intl";
import PropTypes from "prop-types";
import ResponseMessages from "../ResponseMessages";
import PublicLayout from "../../layouts/PublicLayout";

class PasswordPanel extends React.Component {
    render() {
        const { formatMessage } = this.props.intl;

        let view = null;
        let passwordErrors = [];

        if (!this.props.isLoading) {
            if (this.props.showSuccessView) {
                view = this.props.successView;
            } else {
                view = this.props.formView;
            }
            if (this.props.passwordErrors.length > 0) {
                passwordErrors = this.props.passwordErrors.map(error => (
                    <ResponseMessages type={"error"}>
                        {formatMessage({ id: error.reason })}
                    </ResponseMessages>
                ));
            }
        }

        if (this.props.errorMessageId) {
            passwordErrors.push(
                <ResponseMessages type={"error"}>
                    {formatMessage({ id: this.props.errorMessageId })}
                </ResponseMessages>
            );
        }

        return (
            <div className="passwordPanel">
                <PublicLayout
                    title={this.props.header}
                    isLoading={this.props.isLoading}
                    content={view}
                    messages={passwordErrors}
                />
            </div>
        );
    }
}

PasswordPanel.propTypes = {
    intl: intlShape.isRequired,
    formView: PropTypes.object,
    successView: PropTypes.object,
    header: PropTypes.string,
    passwordErrors: PropTypes.array.isRequired,
};

export default injectIntl(PasswordPanel);
